import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const isProduction = (process.env.NODE_ENV !== 'development');


const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            // component: () => import('@/components/LandingPage.vue'),
            ...(
                isProduction ? {
                    component: () => import('@/components/Redirect.vue'),
                } : {
                    redirect: {name: 'login'},
                }
            ),
            // beforeEnter() {
            //     if (isProduction) {
            //         location.href = 'https://www.datacertify.com.br';
            //     }
            // },
        },
        {
            path: '/sound',
            name: 'sound',
            component: () => import('@/components/sound/sound.vue'),
        },
        {
            path: '/lp',
            name: 'lp',
            component: () => import('@/components/LandingPage.vue'),
        },
        // {
        //     path: '/entrar',
        //     name: 'login',
        //     component: () => import('@/components/login/Login.vue'),
        // },
        {
            path: '/cadastro/:origin',
            name: 'pre-signup',
            component: () => import('@/components/login/Login.vue'),
        },
        {
            path: '/completar-cadastro/:code',
            name: 'complete-signup',
            component: () => import('@/components/login/CompleteSignup2.vue'),
        },
        {
            path: '/registro/:record_id',
            name: 'record',
            meta: { title: 'Registro', },
            component: () => import('@/components/records/PublicRecord.vue'),
        },
        {
            path: '/recuperar-senha/:code',
            name: 'recover-password',
            component: () => import('@/components/login/RecoverPassword.vue'),
        },
        {
            path: '/app/',
            name: 'app',
            redirect: { name: 'records' },
            component: () => import('@/components/InternalApp.vue'),
            children: [
                {
                    path: '',
                    redirect: { name: 'records' },
                },
                {
                    path: 'novo-registro',
                    name: 'new-document',
                    meta: { title: 'Novo Registro', },
                    component: () => import('@/components/records/new_record/NewRecord.vue'),
                },
                {
                    path: 'registros',
                    name: 'records',
                    meta: { title: 'Registros', },
                    component: () => import('@/components/records/Records.vue'),
                },
                {
                    path: 'clientes',
                    name: 'clients',
                    meta: { title: 'Clientes', },
                    component: () => import('@/components/account/Clients.vue'),
                },
                {
                    path: 'usuarios',
                    name: 'users',
                    meta: { title: 'Usuários', },
                    component: () => import('@/components/account/Users.vue'),
                },
                {
                    path: 'pagamentos',
                    name: 'billing',
                    meta: { title: 'Assinatura e Pagamentos', },
                    component: () => import('@/components/billing/BillingPage.vue'),
                },
                {
                    path: 'assinar',
                    name: 'subscribe',
                    meta: { title: 'Assinar', },
                    component: () => import('@/components/billing/Subscribe.vue'),
                },
                {
                    path: 'comprar',
                    name: 'individual-purchase',
                    meta: { title: 'Compra de Registros Individuais', },
                    component: () => import('@/components/billing/IndividualPurchase.vue'),
                },
                {
                    path: 'access-codes',
                    name: 'access-codes',
                    meta: { title: 'Códigos de Acesso', },
                    component: () => import('@/components/access_code/AccessCode.vue'),
                },
                {
                    path: 'conta',
                    name: 'account',
                    meta: { title: 'Minha Conta', },
                    component: () => import('@/components/user/Account.vue'),
                },
                {
                    path: 'meus-logins',
                    name: 'sessions',
                    meta: { title: 'Minhas Sessões', },
                    component: () => import('@/components/user/Sessions.vue'),
                },
                {
                    path: 'account-plan',
                    name: 'account-plan',
                    meta: { title: 'Configurar Plano', },
                    component: () => import('@/components/account/AccountPlan.vue'),
                },
                {
                    path: 'suporte',
                    name: 'support',
                    meta: { title: 'Perguntas Frequentes', },
                    component: () => import('@/components/account/Support.vue'),
                },
                {
                    path: 'manual',
                    name: 'trainings',
                    meta: { title: 'Manual da Plataforma', },
                    component: () => import('@/components/manual/Trainings.vue'),
                },
                {
                    path: 'suporte-operacional',
                    component: () => import('@/components/support/SupportHub.vue'),
                    meta: { supportOnly: true, },
                    children: [
                        { path: '', redirect: { name: 'support-record-integrity' } },
                        { path: 'integridade', name: 'support-record-integrity', meta: { title: 'Integridade dos Registros', supportOnly: true, }, component: () => import('@/components/support/RecordIntegrity.vue') },
                        { path: 'logs-clientes', name: 'support-logs', meta: { title: 'Logs dos Clientes', supportOnly: true, }, component: () => import('@/components/support/ClientLogs.vue') },
                    ],
                },
                { path: 'logs-clientes', redirect: { name: 'support-logs' } },
                {
                    path: 'webinars',
                    name: 'webinars',
                    meta: { title: 'Webinars', },
                    component: () => import('@/components/incomplete/Webinars.vue'),
                },
                {
                    path: 'noticias',
                    name: 'news',
                    meta: { title: 'Notícias', },
                    component: () => import('@/components/incomplete/News.vue'),
                },
                {
                    path: 'feedback',
                    name: 'feedback',
                    meta: { title: 'Feedback', },
                    component: () => import('@/components/incomplete/Feedback.vue'),
                },
                {
                    path: 'compartilhe',
                    name: 'share',
                    meta: { title: 'Compartilhe', },
                    component: () => import('@/components/incomplete/Share.vue'),
                },
            ],
        },
    ].filter(route => !isProduction || ['home', 'record'].includes(route.name || '')),
})

router.beforeEach((to, from, next) => {
    const supportOnly = to.matched.some(route => route.meta && route.meta.supportOnly);
    if (!supportOnly) {
        next();
        return;
    }

    if (!store.state.logged) {
        next({ name: 'login' });
        return;
    }

    const user = store.state.user as { is_support?: boolean } | null | undefined;

    if (!user || !user.is_support) {
        next({ name: 'records' });
        return;
    }

    next();
});

export default router;
